'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import NavList from './NavList';
import HR from 'UIComponents/elements/HR';
import H7 from 'UIComponents/elements/headings/H7';

class NestedNav extends Component {
  render() {
    const _this$props = this.props,
          {
      children,
      className,
      divider,
      headingText
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "divider", "headingText"]);

    return /*#__PURE__*/_jsxs(NavList, Object.assign({}, rest, {
      className: className,
      _rootComponent: NestedNav,
      children: [divider ? /*#__PURE__*/_jsx(HR, {}) : null, headingText ? /*#__PURE__*/_jsx(H7, {
        children: headingText
      }) : null, children]
    }));
  }

}

NestedNav.displayName = 'NestedNav';
NestedNav.propTypes = Object.assign({}, NavList.propTypes, {
  divider: PropTypes.bool,
  headingText: PropTypes.node
});
NestedNav.defaultProps = Object.assign({}, NavList.defaultProps, {
  divider: false,
  headingText: ''
});
export default NestedNav;